module.exports = __webpack_public_path__ + "static/media/teamInviteIcon.c3e5667a.png";